export default {
    hrn: '₴',
    hasRemarks: 'Has remarks',
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    validate: {
        Auth: {
            login: {
                required: 'Login is required'
            },
            password: {
                required: 'Password is required',
                minLength: 'Password min length is 6'
            },
            phone: {
                number: 'Phone must be numeric'
            }
        },
        Resale: {
            compensation: {
                required: 'Compensation is required',
                numeric: 'Compensation must be integer'
            },
            price: {
                required: 'Price is required',
                numeric: 'Price must be integer'
            },
            delay: {
                required: 'Delay is required',
                numeric: 'Delay must be integer'
            },
            compensationInPercent: {
                required: 'Compensation in percent is required',
                numeric: 'Compensation in percent must be an integer',
                minValue: 'Value can\'t be less than 0',
                maxValue: 'Value can\'t be greater than 100'
            },
            priceInPercent: {
                required: 'Price in percent is required',
                numeric: 'Price in percent must be an integer',
                minValue: 'Value can\'t be less than 0',
                maxValue: 'Value can\'t be greater than 100'
            },
            optionClassId: {
                required: 'Option class is required'
            }
        },
        Brand: {
            code: {
                required: 'Code is required'
            },
            title: {
                required: 'Title is required'
            },
            phoneNumber: {
                required: 'Phone number is required'
            },
            tax: {
                required: 'Tax is required',
                numeric: 'Tax must be an integer'
            }
        },
        Establishment: {
            name: {
                required: 'Field is required'
            },
            cookTime: {
                required: 'Field is required',
                numeric: 'Field must be integer'
            },
            minimalPrice: {
                required: 'Field is required',
                numeric: 'Field must be integer'
            },
            place: {
                required: 'Field is required'
            },
            commission: {
                required: 'Field is required',
                decimal: 'Field must be a number',
                max: 'Field must not be less than 0',
                min: 'Field must not be greater than 100',
            },
            margin: {
                required: 'Field is required',
                decimal: 'Field must be a number',
                max: 'Field must not be less than 0',
                min: 'Field must not be greater than 100',
            },
            type: {
                name: 'Field is required',
            },
            category: {
                required: 'Field is required'
            },
            brand: {
                required: 'Field is required'
            },
            image: {
                required: 'Choose an image'
            }
        },
        Product: {
            name: {
                required: 'Field is required'
            },
            weight: {
                required: 'Field is required',
                numeric: 'Field must be integer',
                maxLength: 'Value must less than 6 chars'
            },
            price: {
                required: 'Field is required',
                numeric: 'Field must be integer',
                maxLength: 'Value must less than 6 chars'
            },
            establishmentAddressId: {
                required: 'Field is required'
            },
            establishment: {
                required: 'Field is required'
            },
            status: {
                required: 'Field is required',
            },
            brand: {
                required: 'Field is required'
            },
            section: {
                required: 'Field is required'
            },
            image: {
                required: 'Choose an image'
            },
            shortDescription: {
                maxLength: 'Value must less than 255 chars'
            },
            detailedDescription: {
                maxLength: 'Value must less than 400 chars'
            },
        },
        Notifications: {
            title: {
                required: 'Title is required'
            },
            body: {
                required: 'Text is required',
                maxLength: 'Too long'
            }
        },
        Addresses: {
            street: {
                required: 'Street is required'
            },
            name: {
                required: 'Name of place is required'
            },
            city: {
                required: 'City is required'
            },
            houseNumber: {
                required: 'House number is required'
            },
            latitude: {
                required: 'Latitude is required',
                demical: 'Enter the latitude in digits'
            },
            longitude: {
                required: 'Longitude is required',
                demical: 'Enter the longitude in digits'
            }
        },
        Bonuses: {
            amount: {
                required: 'Enter the bonus amount',
                numeric: 'Enter the amount in digits',
                minValue: 'The amount must be greater than 0.',
            },
            brandId: {
                required: 'Choose brand'
            },
            phones: {
                required: 'Enter the phone numbers'
            },
            callSigns: {
                required: 'Enter the drivers callsigns'
            },
            bonusUseLimit: {
                title: {
                    required: "Enter a system name"
                },
                description: {
                    required: "Enter a description for the system"
                },
                bonusFrequency: {
                    required: 'Enter your bonus use frequency',
                    numeric: 'Enter the frequency in numbers',
                    minValue: 'The frequency must be greater than 0'
                },
                bonusValue: {
                    required: 'Enter the bonus amount',
                    numeric: 'Enter the amount in digits',
                    minValue: 'The amount must be greater than 0'
                },
                bonusValueFromDriver: {
                    required: 'Enter the amount of the bonus from the driver',
                    maxValue: 'It should not be more than the bonus amount',
                    numeric: 'Enter the amount in digits',
                    minValue: 'The amount must be greater than 0'
                },
                startDate: {
                    required: 'Enter the program start date'
                },
                endDate: {
                    required: 'Enter the program end date'
                }
            },
            bonusSystem: {
                title: {
                    required: "Enter a system name"
                },
                description: {
                    required: "Enter a description for the system"
                },
                bonusFrequency: {
                    required: 'Enter your bonus use frequency',
                    numeric: 'Enter the frequency in numbers',
                    minValue: 'The frequency must be greater than 0'
                },
                bonusValue: {
                    required: 'Enter the bonus amount',
                    numeric: 'Enter the amount in digits',
                    minValue: 'The amount must be greater than 0'
                },
                bonusMaxAmount: {
                    numeric: 'Enter the maximum bonus amount in numbers'
                },
                skip: {
                    numeric: 'Enter the maximum skips in numbers'
                },
                startDate: {
                    required: 'Enter the program start date'
                },
                endDate: {
                    required: 'Enter the program end date'
                }
            }
        },
        Report: {
            name: {
                required: 'Name is required',
                minLength: 'The minimum number of characters - 2',
                maxLength: 'The maximum number of characters - 255'
            },
            category: {
                maxLength: 'The maximum number of characters - 255',
            },
            sqlQuery: {
                required: 'Enter the SQL query'
            }
        },
        Operators: {
            companyName: {
                required: 'Name is required',
                minLength: 'The minimum number of characters - 3'
            }
        },
        User: {
            firstName: {
                required: "First name is required",
                minLength: 'The minimum number of characters - 2',
                maxLength: 'The maximum number of characters - 30'
            },
            lastName: {
                required: 'Last name is required',
                minLength: 'The minimum number of characters - 2',
                maxLength: 'The maximum number of characters - 30'
            },
            middleName: {
                required: 'Middle name is required',
                minLength: 'The minimum number of characters - 2',
                maxLength: 'The maximum number of characters - 30'
            },
            loginName: {
                required: 'Login is required',
                minLength: 'The minimum number of characters - 2',
                maxLength: 'The maximum number of characters - 30',
                alphaNum: 'Only latin characters allowed'
            },
            phoneNumber: {
                required: 'Phone is required'
            },
            password: {
                required: 'Password is required',
                minLength: 'The minimum number of characters - 6',
                maxLength: 'The maximum number of characters - 30'
            },
            email: {
                required: 'Field is required',
                email: 'Fill in correct email'
            },
            comment: {
                maxLength: 'Only 255 or less characters allowed'
            },
            brandId: {
                required: 'Brand is required'
            }
        },
        CommissionTransfer: {
            commissionId: {
                required: 'Commission is required'
            },
            commissionSystemId: {
                required: 'Commission system is required'
            }
        },
        DriverDetails: {
            callSign: {
                notEmpty: 'Fill in Call sign field',
                required: 'CallSign is required'
            },
            commissionId: {
                required: 'Commission is required'
            },
            minBalance: {
                required: 'Min balance is required',
                isNumeric: 'Only numbers allowed',
                maxValue: 'The entered balance exceeds the allowed',
                minValue: 'The entered balance is below the allowable'
            },
            address: {
                required: 'Address is required'
            },
            passportNumber: {
                required: 'Field is required'
            },
            passportIssuedBy: {
                required: 'Field is required'
            },
            passportIssuedWhen: {
                required: 'Field is required'
            },
            identificationCode: {
                required: 'Field is required'
            }
        },
        DriverLikes: {
            comment: {
                required: 'Field is required'
            }
        },
        Car: {
            year: {
                required: 'Field is required',
                numeric: 'Fill in Year of car manufacture'
            },
            model: {
                required: 'Field is required'
            },
            color: {
                required: 'Field is required'
            },
            make: {
                required: 'Field is required'
            },
            number: {
                required: 'Field is required'
            }
        },
        DriverPayment: {
            paymentSum: {
                required: 'Sum is required',
                numeric: 'Only numbers allowed'
            },
            paymentComment: {
                maxLength: 'Only 255 or less characters allowed',
                required: 'Comment is required'
            },
            penaltyComment: {
                required: 'Comment is required'
            },
            penaltyId: {
                required: 'Select penalty'
            },
            paymentType: {
                required: 'Select payment type'
            },
            orderId: {
                custom: 'Order is required'
            }
        },
        PaymentType: {
            name: {
                required: 'Name is required'
            },
            description: {
                required: 'Description is required'
            }
        },
        DriverPenalty: {
            title: {
                required: 'Title is required'
            },
            fixedPenalty: {
                required: 'Penalty sum is required',
                demical: 'Only numbers allowed'
            },
            brandId: {
                required: 'Brand is required'
            }
        },
        Options: {
            optionName: {
                required: 'Name is required'
            },
            startPrice: {
                required: 'Start sum is required',
                demical: 'Only numbers allowed'
            },
            priceForKm: {
                required: 'Sum for km is required',
                demical: 'Only numbers allowed'
            },
            priceForWaiting: {
                required: 'Sum for waiting is required',
                demical: 'Only numbers allowed'
            },
            minPrice: {
                required: 'Min price is required',
                numeric: 'Only numbers allowed'
            },
            multiplier: {
                required: 'Multiplier is required',
                demical: 'Only numbers allowed'
            },
            multiplierForDriver: {
                required: 'Multiplier for driver is required',
                demical: 'Only numbers allowed'
            },
            brandId: {
                required: 'Brand is required'
            }
        },
        OptionClasses: {
            className: {
                required: 'Class name is required'
            }
        },
        DriverCommission: {
            title: {
                required: 'Title is required'
            },
            fixedPerOrder: {
                required: 'Enter the order fee',
                demical: 'Only numbers allowed'
            },
            fixedPerDay: {
                required: 'Enter your payday',
                demical: 'Only numbers allowed'
            },
            perDayType: {
                required: 'Enter the type of payment per day'
            },
            fixedPerDeliveryOrder: {
                required: 'Enter the delivery order fee',
                demical: 'Only numbers allowed'
            },
            percentagePerDeliveryOrder: {
                required: 'Enter the delivery order fee',
                demical: 'Only numbers allowed'
            },
            fixedPerWeek: {
                required: 'Enter your pay per week of work',
                demical: 'Only numbers allowed'
            },
            fixedPerMonth: {
                required: 'Enter the monthly pay',
                demical: 'Only numbers allowed'
            },
            deliveryDelay: {
                required: 'Enter a delay',
                demical: 'Only numbers allowed'
            },
            brandId: {
                required: 'Brand is required'
            }
        },

        DriverCommissionRecalculate: {
            distance: {
                required: 'Distance is required',
                minValue: 'Value must be greater than 0'
            },
            downtime: {
                required: 'Downtime is required',
                minValue: 'Value must be greater than 0'
            }
        },
        PhotoReport: {
            reason: {
                comment: {
                    required: 'Comment is required'
                },
                name: {
                    required: 'Reason name is required'
                },
                types: {
                    name: {
                        required: 'Photo type is required'
                    }
                }
            },
            photoRequest: {
                name: {
                    required: 'Photo report name is required'
                },
                reasonId: {
                    required: 'Reason is required'
                },
                brandId: {
                    required: 'Brand id required'
                },
                callSigns: {
                    required: 'Call signs are required'
                },
                checkCallSign: {
                    required: 'Call sign is required'
                }
            },
        },
        CommissionSystems: {
            name: {
                required: 'Name is required'
            },
            brandId: {
                required: 'Brand is required'
            },
            period: {
                required: 'Period is required',
                numeric: 'Invalid value',
                min: 'Less than minimum'
            }
        },
        Forms: {
            name: {
                required: 'Name is required'
            }
        },
        FormAnswers: {
            phoneNumber: {
                required: 'Phone number is required',
                length: 'Phone number is incorrect'
            },
            formId: {
                required: 'Form is required'
            },
            status: {
                required: 'Status is required'
            }
        },
        PerOrderBorder: {
            leftBorder: {
                required: 'Enter the left border',
                numeric: 'Only numbers allowed'
            },
            rightBorder: {
                required: 'Enter the right border',
                numeric: 'Only numbers allowed',
                minValue: 'The value of the right boundary should exceed the value of the left boundary'
            },
            staticValue: {
                required: 'Enter a static commission',
                demical: 'Only numbers allowed'
            },
            percentValue: {
                required: 'Enter the interest rate',
                demical: 'Only numbers allowed'
            }
        },
        TechnicalSupport: {
            type: {
                required: 'Call type is required'
            },
            phoneNumber: {
                required: 'Phone number is required',
                length: 'Phone number is incorrect'
            },
            status: {
                required: 'Status is required'
            },
            reason: {
                required: 'Reason is required'
            },
            customReason: {
                required: 'Custom reason is required'
            },
            comment: {
                maxLength: 'Max length - 255 characters'
            }
        }
    },
    menu: {
        technicalSupport: 'Technical support',
        deliveryReports: 'Delivery reports',
        receiveOrders: 'Receive orders',
        driverArticleEditor: 'Editing drivers\' article',
        articleList: 'Article list',
        formAnswers: 'Interviews',
        importProducts: 'Import products',
        dispatcher: {
            title: 'Dispatcher',
            receiveOrders: 'Receive Orders',
            technicalSupport: 'Technical support',
            formAnswers: 'Interviews'
        },
        // --- Delivery ---
        delivery: {
            title: 'Delivery',
            importProducts: 'Import products',
            establishmentsCategories: 'Establishments categories',
            establishmentsTypes: 'Establishments types',
            establishments: 'Establishments',
            sections: 'Sections',
            products: 'Goods',
            deliveryReports: 'Delivery reports'
        },
        establishmentsCategories: 'Establishments categories',
        establishmentsTypes: 'Establishments types',
        establishments: 'Establishments',
        sections: 'Sections',
        products: 'Goods',
        // --- Delivery end ---
        driverNews: {
            title: 'Driver news',
            articleList: 'Article list',
            addDriverArticle: 'Add article',
        },
        addDriverArticle: 'Creation of driver article',
        history: 'History',
        map: 'Map',
        finances: {
            title: 'Finances',
            tariffs: 'Tariffs',
            commissions: 'Commissions',
            'commission-systems': 'Commission Systems',
            penalties: 'Penalties',
            optionClasses: 'Option classes',
            paymentTypes: 'Payment types'
        },
        users: {
            title: 'Lists',
            operators: 'Users',
            drivers: 'Drivers',
            clients: 'Clients'
        },
        settings: {
            title: 'Settings',
            admin: 'For admin',
            boss: 'For boss'
        },
        resales: 'Resales',
        brands: 'Brands',
        bonuses: {
            title: 'Bonuses',
            driver: 'For driver',
            client: 'For client'
        },
        photoReport: {
            title: 'Photo report',
            reasons: 'Reasons list',
            review: 'Photo report review',
            reasonCreate: 'Create reason',
            requestCreate: 'Create photo report',
            reports: 'Photo reports list'
        },
        logging: 'Activity',
        loggingEditor: 'Activity edit',
        login: 'Login',
        reports: 'Reports',
        addresses: 'Addresses',
        notifications: 'Notifications',
        logout: 'Logout',
        forms: 'Forms'
    },
    models: {
        Driver: {
            make: 'Car make',
            year: 'Manufacture year',
            color: 'Car color',
            email: 'Email',
            model: 'Car model',
            number: 'Car number',
            pledge: 'Pledge',
            address: 'Address',
            brandId: 'Brand id',
            brand: 'Brand',
            comment: 'Comment',
            options: 'Options',
            callSign: 'Call sign',
            lastName: 'Last name',
            firstName: 'First name',
            commission: 'Commission',
            commissionSystem: 'Commission System',
            middleName: 'Middle name',
            minBalance: 'Min balance',
            phoneNumber: 'Phone',
            commissionId: 'Commission Id',
            additionalAdresses: 'Additional addresses',
            additionalPhoneNumbers: 'Additional phone',
            passportNumber: 'Series and Number',
            passportIssuedBy: 'Issued by',
            passportIssuedWhen: 'Issued when',
            identificationCode: 'Identification code',
            comments: 'Comments',
            leaderId: 'Leader ID'
        },
        Client: {
            email: 'Email',
            brandId: 'Brand id',
            brand: 'Brand',
            birthday: 'Birthday',
            lastName: 'Last name',
            roleName: 'Role name',
            firstName: 'First name',
            phoneNumber: 'Phone number',
            comment: 'Comment'
        },
        Operator: {
            id: 'Id',
            email: 'Email',
            brandId: 'Brand id',
            brand: 'Brand',
            comment: 'Comment',
            lastName: 'Last name',
            roleName: 'Role name',
            firstName: 'First name',
            loginName: 'Login name',
            middleName: 'Middle name',
            phoneNumber: 'Phone number',
            canEditClients: 'Display orders of other operators',
            canEditDrivers: 'Can edit drivers',
            canChangeOptionLevel: 'Can change option level'
        },
        ClientBonus: {
            title: 'Title',
            brandId: 'Brand id',
            brand: 'Brand',
            endDate: 'End date',
            isActive: 'Is active',
            startDate: 'Start date',
            bonusValue: 'Bonus value',
            description: 'Description',
            bonusFrequency: 'Bonus frequency',
            bonusValueFromDriver: 'Bonus value from driver'
        },
        Tariff: {
            hidden: 'Hidden',
            brandId: 'Brand id',
            brand: 'Brand',
            districtName: 'District',
            minPrice: 'Min price',
            districtId: 'District id',
            multiplier: 'Multiplier',
            internal: 'Internal',
            defaultOptions: 'Default option',
            priceForKm: 'Price for km',
            startPrice: 'Start price',
            description: 'Description',
            optionClassId: 'Option class id',
            priceForWaiting: 'Price for waiting',
            multiplierForDriver: 'Multiplier for driver',
            optionName: 'Type',
            className: 'Tariff',
            numberOfSits: 'Number of sits'
        },
        Resale: {
            delay: 'Delay',
            price: 'Price',
            compensation: 'Compensation',
            priceInPercent: 'Price in percent',
            compensationInPercent: 'Compensation in percent'
        },
        Commission: {
            title: 'Title',
            brandId: 'Brand Id',
            brand: 'Brand',
            isDefault: 'Is default',
            perDayType: 'Per day type',
            fixedPerDay: 'Fixed per day',
            fixedPerWeek: 'Fixed per week',
            deliveryDelay: 'Delivery delay',
            fixedPerMonth: 'Fixed per month',
            fixedPerOrder: 'Fixed per order'
        },
        CommissionBorder: {
            leftBorder: 'Left border',
            rightBorder: 'Right border',
            staticValue: 'Static value',
            percentValue: 'Percent value',
            commissionTitle: 'Commission title'
        },
        Penalty: {
            title: 'Title',
            brandId: 'Brand id',
            brand: 'Brand',
            fixedPenalty: 'Fixed penalty'
        },
        DriverBonus: {
            title: 'Title',
            brandId: 'Brand id',
            brand: 'Brand',
            endDate: 'End date',
            isActive: 'Is active',
            startDate: 'Start date',
            bonusValue: 'Bonus value',
            description: 'Description',
            bonusFrequency: 'Bonus frequency',
            bonusMaxAmount: 'Bonus max amount',
            takeOtherBrandOrders: 'Take other brand orders'
        },
        Settings: {
            value: 'Value',
            comment: 'Comment',
            forDirector: 'for director',
            forAdmin: 'for admin'
        },
        Report: {
            name: 'Name',
            category: 'Category',
            sqlQuery: 'Sql query',
            meta: 'SQL metadata',
            useDates: 'Filter by date',
            useTimes: 'Filter by time',
            useQuery: 'Text query',
            useBrand: 'Filter by brand',
            useCorp: 'For corporate clients',
            useCompany: 'Filter by company'
        },
        Payment: {
            withdrawal: 'Withdrawal',
            deposit: 'Deposit',
            penalty: 'Penalty'
        }
    },
    pages: {
        Delivery: {
            addressSchedule: 'Address schedule',
            Categories: {
                visibility: {
                    shown: 'Shown',
                    hidden: 'Hidden'
                },
                deleting: 'Deleting category',
                areYouSureToDelete: 'Are you sure to delete category?'
            },
            ImportProducts: {
                chooseAFile: 'Choose a file',
                fileToImport: 'File to import',
                validationResults: 'Validation results',
                chooseEstablishmentAddress: 'Choose establishment address',
                productErrors: 'Product errors',
                newSections: 'New sections',
                products: 'Products',
                validate: 'Validate',
                howToCreateImportFile: 'How to create import file?',
                importFileInstructions: `Це zip архів з csv файлом і картинками
Csv файл має бути з назвою import.csv
Колонки в csv файлі:
Name назва продукту
Count кількість продукту
QuantityType - тип кількості продукту (г, мл, шт, кг)
Price - ціна
Section - назва розділу
ShortDescription - короткий опис
DetailedDescription - опис продукту
Image - назва файлу картинки`,
                productStatuses: {
                    new: 'New',
                    updated: 'Updated',
                },
                import: 'Import',
            },
            Products: {
                price: 'Price',
                section: 'Section',
                amount: 'Amount',
                picture: 'Picture',
                shortDescription: 'Short description',
                detailedDescription: 'Detailed description',
                new: 'New',
            },
            photo: 'Photo',
            airAlarm: 'Air alarm'
        },
        History: {
            status: 'Status',
            deliveryStatus: 'Delivery status',
            reason: 'Reason',
            brand: 'Brand',
            all: 'All',
            filterTitle: 'Reset filter',
            scope: 'Target',
            establishment: 'Establishment',
            table: {
                actions: '',
                id: '#',
                deliveryCancelReason: 'Cancel reason',
                createdAt: 'Created at',
                gettingOrderTime: 'Order receipt time',
                status: 'Status',
                statusesHistory: 'Statuses history',
                client: 'Client',
                address: 'Address of order',
                additionAddresses: 'Additional addresses',
                options: 'Options',
                commentForEstablishment: 'Comment for establishment',
                cookTime: 'Cooking time',
                establishment: 'Establishment',
                courierStatus: 'Courier status',
                problem: 'Problem',
                countOfPersons: 'Appliances',
                products: 'Products',
                manager: 'Manager',
                managerPhoneNumber: 'Manager\'s phone',
                arrivalTime: 'Arrival time',
                car: 'Car',
                brandId: 'Brand',
                operator: 'Operator',
                comments: 'Comments',
                price: 'Price',
                calculatedPrice: 'Calculated price',
                tips: 'Tips',
                route: 'Route',
                routeLength: 'Route length',
                stayTime: 'Idle time',
            }
        },
        DashboardMap: {
            settings: 'Map setup',
            showDrivers: 'Display drivers',
            showGroupOrders: 'Display group orders',
            showNewOrders: 'Display new orders',
            allBrands: 'All brands',
            orderIdPlaceholder: 'Enter order number',
            errors: {
                accessDenied: 'You are not authorized to view this order.',
                orderNotFound: 'The order with the specified Id does not exist.',
                noRouteInfo: 'There is no route information in this order.'
            }
        },
        Auth: {
            title: 'Login',
            login: 'Login',
            password: 'Password',
            phone: 'SIP'
        },
        Settings: {
            requiredBrand: 'Select the brand for which you want to display the settings',
            brand: 'Brand',
            edit: 'Edit setting',
            default: 'Default settings',
            usedDefault: 'Basic settings is used for this brand',
            action: 'Off/On',
            table: {
                key: 'Key',
                value: 'Value',
                type: 'Type of value',
                comment: 'Comment',
                action: 'Actions'
            },
            types: {
                bots: 'Bots',
                driverUdp: 'Driver app',
                notifications: 'Notifications',
                payments: 'Payment systems',
                publicApi: 'Public site',
                karma: 'Karma',
                public: 'Public app',
                paymentApi: 'Payments',
                businessSystem: 'Business system',
                delivery: 'Delivery'
            }
        },
        Brands: {
            brandHasActiveEstablishments: 'Chosen brand has active establishments',
            cannotRemoveTitle: 'Cannot delete brand',
            filters: {
                query: 'Query',
                removed: 'Removed'
            },
            table: {
                code: 'Code',
                is_vip: 'VIP',
                title: 'Title',
                phoneNumber: 'Phone',
                domain: 'Domain',
                defaultOptionId: 'Default option',
                fromCurbOptionId: 'Curb default option',
                tax: 'Tax',
                actions: 'Actions',
                removeTitle: 'Remove brand',
                removeQuestion: 'Are you sure want to remove this brand ?'
            }
        },
        Forms: {
            table: {
                id: 'Form ID',
                name: 'Name',
                description: 'Description',
                count: 'Count of components',
                createdAt: 'Created At',
                updatedAt: 'Updated At',
                actions: 'Actions',
                removeQuestion: 'Are you really want to remove this form ?',
                removeDescription: 'This form will be removed from the system'
            },
            editor: {
                create: 'Create form',
                edit: 'Edit form',
                fill: 'Fill form'
            },
            components: {
                text: 'Text',
                type: 'Type',
                order: 'Order',
                options: 'Options',
                emptyOptions: 'Options not created',
                actions: 'Actions'
            },
            types: {
                text: 'Text',
                'simple-question': 'Simple question',
                'complex-question': 'Complex question',
                'single-choice': 'Single choice',
                'multiple-choice': 'Multiple choice'
            }
        },
        FormAnswers: {
            history: 'Answers history',
            table: {
                id: 'Interview ID',
                status: 'Status',
                comment: 'Comment',
                client: 'Client',
                phoneNumber: 'Phone number',
                form: 'Title',
                operator: 'Operator',
                createdAt: 'Created at',
                actions: 'Actions'
            },
            statuses: {
                'new': 'New',
                'not-interested': 'Not interested',
                'cannot-connect': 'Can\'t connect client',
                'call-terminated': 'Call terminated',
                'to-quality-control': 'To quality control',
                'call-back-later': 'Call back later',
                'success': 'Success',
                'app-success': 'Success from app',
                'telephony-success': 'Success from telephony',
                'quality-control-success': 'Quality control success',
                'quality-control-failure': 'Quality control failure',
                'returned-promotion-retain': 'Returned by himself - dont remove from promotion',
                'returned-promotion-remove': 'Returned by himself - remove from promotion'
            },
            editor: {
                title: 'Form answer',
                phoneNumber: 'Phone number',
                formId: 'Form',
                status: 'Status',
                comment: 'Comment',
                questions: 'Questions'
            }
        },
        ResalesList: {
            brand: 'Brand',
            switch: 'Dealer/Buyer',
            edit: 'Edit resale',
            buyer: 'Buyer',
            dealer: 'Dealer',
            compensation: 'Compensation',
            price: 'Price',
            compensationInPercent: 'Compensation in percents',
            priceInPercent: 'Price in percents',
            delay: 'Delay',
            percents: 'Choose in percents'
        },
        BrandEditor: {
            create: 'Create brand',
            edit: 'Edit brand',
            code: 'Code',
            title: 'Title',
            phoneNumber: 'Phone',
            domain: 'Domain',
            defaultOptionId: 'Default option',
            fromCurbOptionId: 'Curb default option',
            tax: 'Tax'
        },
        Notifications: {
            success: 'Success',
            failure: 'Failure',
            count: 'Count of notifications',
            callSigns: 'Call signs',
            brands: 'Brands',
            driverStatus: 'Driver status',
            optionClasses: 'Option classes',
            commissions: 'Commissions',
            startDate: 'Start date',
            endDate: 'End date',
            sentNotification: 'Sent notification',
            title: 'Title',
            body: 'Text',
            imageLink: 'Image link',
            description: 'A notification will be sent to the selected driver list',
            result: 'Result'
        },
        ReceiveOrders: {
            assign: 'Assign',
            assignDriver: 'Assign driver to the order',
            assignedSuccessfully: 'Driver {0} successfully assigned to the order.',
            assignError: 'Error while assigning driver to the order.',
            title: 'Orders',
            createOrderTitle: 'Order',
            ordersSearch: 'Search',
            customer: 'Customer',
            address: 'Presentation address',
            house: 'House',
            street: 'Street',
            gotAProblem: 'Problem with order!',
            search: 'Start typing to search ...',
            outCity: 'Out city',
            comment: 'Comment',
            commentLabel: 'Comment (apartment / porch / what to carry)',
            addAddress: 'Add address',
            arrival: 'Arrival',
            when: 'When',
            now: 'Now',
            today: 'Today',
            tomorrow: 'Tomorrow',
            brand: 'Brand',
            orderAddress: 'Current order location',
            autoType: 'Auto type',
            orderHistory: 'Order history',
            autoRequirements: 'Auto requirements',
            tip: 'Tip',
            changeNumber: 'Change number',
            copyNumber: 'Copy number',
            waiting: 'Waiting',
            cancel: 'Cancel',
            driver: 'Driver',
            noAddress: 'No address',
            noPhone: 'Incorrect phone number',
            callSign: 'Call sign',
            preOrder: 'Pre-order',
            minPreOrderTime: 'Minimum time to pre-order',
            forced: 'Forced appointment',
            nearestCars: 'Nearest cars',
            appoint: 'Appoint',
            forTea: 'For tea',
            sum: 'In sum',
            route: 'Route',
            km: 'km',
            hrn: 'hrn',
            min: 'min',
            recalculate: 'Recalculate',
            duplicate: 'Duplicate',
            noCars: 'No cars',
            backToSearch: 'Return to search',
            calculate: 'Calculate',
            save: 'Save',
            edit: 'Edit',
            searchAuto: 'Search auto',
            searchDriver: 'Enter the call sign of the driver',
            discount: 'Discount',
            corporateUser: 'Corporate user',
            bonusesDiscount: 'Trips before discounts',
            increaseTariff: 'Increase tariff',
            goBack: 'Go back',
            acceptOrder: 'Accept order',
            orderCancellation: 'Order cancellation',
            searchCourier: 'Search courier',
            enterCancelReason_textWillBeSentToClient: 'Please enter cancel reason. Typed text will be sent to customer',
            switchStatus: 'Switch status',
            prepareTime: 'Preparation time (in minutes)',
            delegationOfOrders: 'Delegation of orders to another operator',
            chooseOrderReceiver: 'Choose order receiver',
            transfer: 'Transfer',
            operatorName: 'Operator\'s name',
            establishment: 'Establishment',
            clientAddress: 'Client\'s address',
            establishmentManager: 'Establishment manager',
            client: 'Customer',
            countOfPersonsDeclinated1: 'for %s person',
            countOfPersonsDeclinated2: 'for %s persons',
            countOfPersonsDeclinated5: 'for %s persons',
            operator: 'Operator',
            orderDetails: 'Order details',
            commentForEstablishment: 'Comments for establishment',
            cancelOrderDetails: {
                details: 'Cancel details',
                questionType: 'Question type',
                explanation: 'Explanation',
                resolved: 'Resolved',
                unresolved: 'Unresolved',
                questionsList: {
                    'with-driver': 'Question with driver',
                    'with-client': 'Question with client'
                },
                explanationsList: {
                    'corporation-sum': 'Corporation sum',
                    'app-question': 'Question about app',
                    'order': 'About order',
                    'pre-order': 'About pre order',
                    'accident-call': 'Accident call',
                    'sos': 'SOS',
                    'no-sms': 'No sms',
                    'no-car': 'No car',
                    'tariffs-explanation': 'Tariffs explanation',
                    'complaint-receive': 'Complaint receive',
                    'additional-calls': 'Additional calls',
                    'admin-transfer': 'Transfer to administrator',
                    'manager-transfer': 'Transfer to manager',
                    'custom': 'Other'
                }
            },
            reducedTariff: 'Reduced tariff',
            previousTariff: 'Previous tariff is - <b>"{0}"</b>',
            delivery: {
                statuses: {
                    new: 'New',
                    canceledKitchen: 'Cancelled kitchen',
                    notAccepted: 'Not accepted',
                    accepted: 'Accepted',
                    paid: 'Paid',
                    paymentWait: 'Wait for payment',
                    cooking: 'Cooking',
                    canceledClient: 'Cancelled by client',
                    canceledClientPayment: 'Client payment cancelled',
                    readyForDelivery: 'Ready for delivery',
                    handedToCourier: 'Handed to courier',
                    delivered: 'Delivered'
                }
            },
            settingCurrentOptionLevel: 'Setting current option level',
            currentOptionLevel: 'Current option level',
            newValue: 'New value'
        },
        Addresses: {
            table: {
                street: 'Street',
                name: 'Place name',
                'street:uk': 'Street (uk)',
                'name:uk': 'Place name (uk)',
                'city:uk': 'City (uk)',
                'street:ru': 'Street (ru)',
                'name:ru': 'Place name (ru)',
                'city:ru': 'City (ru)',
                'street:en': 'Street (en)',
                'name:en': 'Place name (en)',
                'city:en': 'City (en)',
                houseNumber: 'House number',
                latitude: 'Latitude',
                longitude: 'Longitude',
                action: 'Actions'
            },
            latitude: 'Latitude*',
            longitude: 'Longitude*',
            edit: 'Edit address',
            create: 'Create address',
            withoutCoordinates: 'Without coordinates',
            orderId: 'Order id'
        },
        Bonuses: {
            types: {
                distance: 'By the traveled distance',
                count: 'By order count'
            },
            targetTypes: {
                all: 'All',
                taxi: 'Taxi',
                delivery: 'Delivery'
            },
            table: {
                type: 'Bonus system type',
                title: 'System name',
                description: 'System description',
                bonusFrequency: 'Bonus Frequency',
                bonusValue: 'Bonus amount(UAH)',
                bonusMaxAmount: 'Maximum bonus amount',
                fixedBonusAmount: 'Fixed bonus',
                bonusMaxOrderAmount: 'Maximum bonus for order',
                startDate: 'Program start',
                endDate: 'Program end',
                isActive: 'Active',
                brandId: 'Brand',
                targetType: 'Target type',
                driverCount: 'Active drivers',
                receivedBonuses: 'Bonus Received',
                actions: 'Actions',
                bonusValueFromDriver: 'Bonus from driver(UAH)',
                usersCount: 'Active users',
                refillBalance: 'Bonuses accrued',
                useBalance: 'Bonuses spent',
                leftBalance: 'Bonuses left',
                revertBalance: 'Charged off bonuses',
                skip: 'Skip'
            },
            editor: {
                addBonuses: 'Add bonuses',
                addBonusesAgain: 'Add bonuses again',
                title: 'Bonus accrual',
                phoneNumbers: 'Phone numbers',
                callSigns: 'Drivers call',
                bonusAmount: 'Number of bonuses (UAH)',
                bonusSystem: 'Bonus system',
                bonusSystemName: ':bonusValue UAH. each :bonusFrequency trip (from :startDate to :endDate)',
                generatedSmsText: 'You have been charged :amount UAH. bonus. From :startDate to :endDate discount :bonusValue UAH. for each :bonusFrequency trip.',
                generatedSmsTextForDriver: 'Congratulations! You joined the :brandName event. For each :bonusFrequency order receive :bonusValue UAH bonus',
                transferBonuses: 'Save previous bonuses',
                smsSend: 'Send sms message',
                smsTransliteration: 'Transliterate',
                smsText: 'Sms text',
                mainTitle: 'Bonus System',
                mainTitleForDriver: 'Bonus system for drivers',
                takeOtherBrandOrders: 'Other service orders',
                removeQuestion: 'Want to remove the bonus system?',
                removeDescription: 'This bonus system will be completely removed'
            },
            info: {
                callSign: 'Call sign',
                phone: 'Phone',
                refillBalance: 'Bonuses accrued',
                useBalance: 'Bonuses used',
                revertBalance: 'Bonuses written off',
                leftBalance: 'No bonuses used',
                orderCount: 'Number of trips',
                bonusOrderCount: 'Number of bonus trips',
                receivedBonuses: 'Bonuses received',
                brandOrderCount: 'Brand orders',
                totalOrderCount: 'All orders',
                details: 'Detailed information',
                noActiveUsers: 'There are no active users in this bonus system',
                successAdded: 'Accrued successfully',
                countOfBonuses: 'Number of bonuses accrued',
                countOfTransferedBonuses: 'Number of bonuses transferred from other systems'
            },
            validate: {
                success: 'Success',
                notFound: 'Not found',
                duplicate: 'Duplicate',
                otherBonusSystem: 'Other bonus systems',
                validationError: 'Validation error'
            }
        },
        DeliveryReports: {
            table: {
                date: 'Date',
                orderCnt: 'Order count',
                cancelledCnt: 'Cancelled orders',
                commissionPercent: 'Commission percent',
                paidCommission: 'Paid commission',
                earned: 'Sum of sold products',
                clearProfit: 'Clear profit',
                soldSum: 'Sum of sold products',
                brandLoan: 'Brand loan',
                totalCommission: 'Total commission',
                bonusOrderCnt: 'Bonus order count',
                productSum: 'Sum of sold products',
                deliveryPrice: 'Total delivery price',
                driverBonusAmount: 'Sum of driver bonuses',
                totalRouteLength: 'Route length sum',
                totalMargin: 'Total margin',
                deliveryOrderId: 'Order id',
                callSign: 'Call sign',
                driverDistance: 'Distance to establishment',
                forcedOrdersCount: 'Forced orders count',
                forcedOrdersAcceptedCount: 'Forced orders accepted count',
                forcedOrdersDeclinedCount: 'Forced orders declined count',
                orderCreated: 'Order creation datetime',
                orderOpened: 'Order opening datetime',
                orderID: 'Order id',
                openDuration: 'Order opening duration',
                managerFIO: 'Manager\'s full name',
                finalOrderStatus: 'Final order status',
                orderAccepted: 'Order acceptance datetime',
                acceptedDuration: 'Order acceptance duration',
                operatorFIO: 'Operator\'s full name',
                avgAcceptedDuration: 'Average order acceptance duration',
                minAcceptedDuration: 'Minimum order acceptance duration',
                maxAcceptedDuration: 'Maximum order acceptance duration',
                ordersCount: 'Orders count',
                avgOpenDuration: 'Average order opening duration',
                minOpenDuration: 'Minimum order opening duration',
                maxOpenDuration: 'Maximum order opening duration',
                successfullyTestOrdersCnt: 'Count of successful test orders',
                canceledTestOrdersCnt: 'Count of canceled test orders',
                canceledTestOrdersSum: 'Canceled test orders sum',
                canceledOrdersByClientBeforePaymentCnt: 'Count of canceled orders by client before payment',
                canceledOrdersByClientAfterPaymentCnt: 'Count of canceled orders by client after payment',
                canceledOrdersByClientAfterPaymentSum: 'Canceled orders by client after payment sum',
                canceledOrdersByEstBeforePaymentCnt: 'Count of canceled orders by establishment before payment',
                canceledOrdersByEstAfterPaymentCnt: 'Count of canceled orders by establishment after payment',
                canceledOrdersByEstAfterPaymentSum: 'Canceled orders by establishment after payment sum',
                taxiOrderId: 'Order id',
                distanceToClient: 'Distance to client',
            },
            types: {
                dailyProfit: 'Company manager\'s report #1',
                brandFinance: 'Financial by brand',
                deliveryDriverBonuses: 'Extra charge for drivers',
                productAnalytics: 'Company manager\'s report #2',
                forcedAnalyticsAccepted: 'Forced order acceptance analytics',
                forcedAnalyticsDeclined: 'Forced order decline analytics',
                canceledAndTestOrders: 'Canceled and test orders',
                managerAnalytics: 'Manager work analytics',
                operatorMainAnalytics: 'Operator work analytics (common)',
                managerMainAnalytics: 'Manager work analytics (common)',
                forcedAnalyticsDeclinedTaxi: 'Forced order decline analytics',
            },
            categories: {
                financialDeliveryReports: 'Financial delivery reports',
                forcedAnalytics: 'Work with couriers',
                orderProcessingAnalytics: 'Order processing analytics',
                operatorAnalytics: 'Operator work analytics',
                forcedAnalyticsTaxi: 'Work with drivers',
            },
            all: 'Delivery reports',
            allEstablishments: 'All establishments',
            allBrands: 'All brands',
            establishment: 'Establishment',
            brand: 'Brand'
        },
        Reports: {
            all: 'Reports',
            another: 'Another',
            category: 'Category',
            report: 'Report',
            empty: 'You do not have access to any reports.',
            query: 'Query',
            brand: 'Brand',
            company: 'Company',
            startDate: 'Start Date',
            orderId: 'Order id',
            endDate: 'End Date',
            startTime: 'Start time',
            endTime: 'End time',
            table: {
                number: '#',
                name: 'Name',
                category: 'Category',
                sqlQuery: 'Sql query',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                action: 'Action'
            },
            editor: {
                create: 'Create a report',
                edit: 'Edit a report',
                meta: 'SQL meta',
                useDates: 'Filter by date',
                useTimes: 'Filter by time',
                useQuery: 'Text request',
                useBrand: 'Filter by brand',
                useCorp: 'For corporate clients',
                useCompany: 'Filter by company',
                removeQuestion: 'Want to remove the report?',
                removeDescription: 'This report will be completely removed'
            }
        },
        Users: {
            query: 'Query',
            startDate: 'Start date',
            endDate: 'End date',
            all: 'All',
            table: {
                userId: '#',
                birthday: 'Birthday',
                fullName: 'Full name',
                firstName: 'First name',
                lastName: 'Last name',
                middleName: 'Middle name',
                establishmentAddress: 'Establishment address',
                phoneNumber: 'Phone',
                email: 'Email',
                comment: 'Comment',
                loginName: 'Login name',
                roleName: 'Role',
                establishmentAddressId: 'Establishment address',
                createdAt: 'Start work at',
                updatedAt: 'End work at',
                lastActiveTime: 'Last active time',
                brandId: 'Brand',
                actions: 'Actions',
                callSign: 'CallSign',
                driverStatus: 'Status',
                shortCarInfo: 'Car',
                imei: 'IMEI',
                address: 'Address',
                commission: 'Commission',
                karma: 'Karma',
                commissionSystem: 'Commission System',
                minBalance: 'Min balance',
                additionalPhoneNumbers: 'Additional phones',
                additionalAdresses: 'Additional addresses',
                pledge: 'Pledge',
                password: 'Password',
                canEditClients: 'Display orders of other operators',
                canChangeOptionLevel: 'Can change option level',
                canEditDrivers: 'Can edit drivers',
                extendedCapabilities: 'Extended capabilities',
                leaderId: 'Leader',
                establishmentId: 'Establishment',
                categoryId: 'Category'
            },
            client: {
                edit: 'Edit client',
                create: 'Create client'
            },
            operator: {
                edit: 'Edit user',
                create: 'Create user',
                removeQuestion: 'Would you like to delete this user?',
                removeDescription: 'This user will be set to status - deleted.',
                company: {
                    edit: 'Company editing',
                    title: 'Company name'
                }

            },
            driver: {
                edit: 'Edit driver',
                create: 'Create driver',
                options: 'Options',
                tariffs: 'Tariffs',
                removeQuestion: 'Would you like to delete this driver?',
                removeDescription: 'This driver will be set to status - deleted.',
                payments: 'Payments history',
                changePasswordText: 'New password:',
                comments: 'Comments',
                newComment: 'New comment',
                reRegistration: 'Re-Registration',
                additionalDriver: 'Additional account',
                withoutAdditionalDriver: 'Not created',
                tied: 'Tied',
                deliveryConfidence: 'Admission to delivery orders',
                confidenceLevels: {
                    under: 'Under',
                    all: 'All'
                },
                mainDriver: 'Main account',
                present: 'Present',
                disabled: {
                    title: 'Blocking of untested drivers',
                    text: 'Select the minimum date of the last check to be able to be on the air. All drivers with a last check date less than (or no date at all) specified will be discarded.'
                },
                car: {
                    year: 'Year',
                    make: 'Make',
                    model: 'Model',
                    color: 'Color',
                    number: 'Number'
                },
                status: {
                    active: 'Active',
                    offline: 'Active',
                    disabled: 'Disabled',
                    online: 'Online',
                    removed: 'Removed'
                },
                driverOptions: {
                    disable: 'Disable',
                    enable: 'Enable',
                    edit: 'Edit',
                    clearImei: 'Clear IMEI',
                    clearCode: 'Clear App Code',
                    sendPassword: 'Send password'
                },
                passportData: {
                    title: 'Passport Data',
                    number: 'Series and Number',
                    issuedBy: 'Issued by',
                    issuedWhen: 'Issued when',
                    identificationCode: 'Identification code'
                }
            },
            payments: {
                addPenalty: 'Add penalty',
                addPayment: 'Add payment',
                penalty: 'Penalty',
                penaltyComment: 'Penalty comment',
                commissionText: 'Penalty:',
                payment: 'Payment',
                balance: 'Balance',
                paymentTypeByComment: 'Payment type (comment)',
                paymentType: 'Payment type',
                noItems: 'No payments found for the specified parameters.',
                paymentSum: 'Payment sum',
                paymentComment: 'Payment comment',
                createdAt: 'Date',
                orderId: 'Order',
                fullNameForPayment: 'Add by',
                types: {
                    'manual-replenishment': 'Manual replenishment',
                    'cashless-sprut': 'Cashless Sprut',
                    'cashless-manual': 'Cashless Manual',
                    'cash-out': 'Cash out',
                    'receipt': 'Receipt',
                    'employee': 'Employee',
                    'mistake': 'Mistake',
                    'transfer-plus': 'Transfer plus',
                    'transfer-minus': 'Transfer minus',
                    'penalty': 'Penalty',
                    'return': 'Return'
                },
                commission: {
                    recalculate: 'Recalculate commission',
                    distance: 'Distance (km)',
                    downtime: 'Downtime (minutes)',
                    warning: 'Commission will be changed on save',
                    total: 'Total commission is'
                }
            }
        },
        Options: {
            optionClass: 'Option class',
            optionName: 'Tariff',
            brand: 'Brand',
            table: {
                optionName: 'Tariff',
                optionClassId: 'Option class',
                districtId: 'District',
                description: 'Description',
                startPrice: 'Start price',
                priceForKm: 'Price for km',
                priceForWaiting: 'Price for waiting',
                minPrice: 'Min price',
                multiplier: 'Multiplier',
                multiplierForDriver: 'Multiplier for driver',
                defaultOptions: 'Default',
                internal: 'Internal',
                hidden: 'Hidden',
                brandId: 'Brand',
                actions: 'Actions',
                duplicate: 'Duplicate tariff',
                numberOfSits: 'Number of sits'
            },
            editor: {
                create: 'Create tariff',
                edit: 'Edit tariff',
                removeQuestion: 'Would you like to remove this tariff?',
                removeDescription: 'This tariff will be completely removed.',
            },
        },
        OptionClasses: {
            list: {
                towing: 'Towing',
                apart_delivery: 'Apart delivery',
                'apart-delivery': 'Apart delivery',
                pump: 'Pump',
                smoke: 'Smoke',
                drive: 'Drive',
                'for-testing': 'For testing (QA)',
                corporate: 'Corporate',
                'child-escort': 'Child escort',
                'child-car-seat': 'Child car seat',
                animals: 'Animals',
                delivery: 'Delivery',
                cashless: 'Cashless',
                technical: 'Technical',
                promo: 'Promo',
                test: 'Test',
                economy: 'Economy',
                cargo: 'Cargo',
                forced: 'Forced',
                'pre-order': 'Pre-order',
                wagon: 'Wagon',
                van: 'Van',
                comfort: 'Comfort',
                standart: 'Standard',
                premium: 'Premium',
                bonuses: 'Bonuses',
                'food-delivery': 'Food delivery',
            },
            table: {
                id: 'ID',
                className: 'Class name',
                actions: 'Actions'
            },
            create: 'New option class',
            edit: 'Edit option class',
            remove: 'Remove option class',
            removeQuestion: 'Are you really want to remove this option class ?'
        },
        PaymentTypes: {
            filters: {
                query: 'Query'
            },
            table: {
                name: 'Name',
                description: 'Description',
                orderRequired: 'Order required',
                hidden: 'Hidden',
                createdAt: 'Created at',
                actions: 'Actions'
            },
            create: 'New payment type',
            edit: 'Edit payment type',
            remove: 'Remove payment type',
            removeQuestion: 'Are you really want to remove this payment type ?'
        },
        Commissions: {
            title: 'Commission',
            status: 'Status',
            brand: 'Brand',
            statusesList: {
                active: 'Active',
                inactive: 'Inactive',
                removed: 'Removed'
            },
            table: {
                title: 'Title',
                countOfDrivers: 'Count of drivers',
                fixedPerOrder: 'Payment per Order(UAH)',
                fixedPerDay: 'Payment per Day(UAH)',
                perDayType: 'Type of daily payment',
                fixedPerWeek: 'Payment per Week(UAH)',
                fixedPerMonth: 'Payment per Month(UAH)',
                deliveryDelay: 'Delay(seconds)',
                isDefault: 'Default',
                fixedPerDeliveryOrder: 'Payment per delivery order(UAH)',
                percentagePerDeliveryOrder: 'Percentage per delivery order(%)',
                brandId: 'Brand',
                hasPrecedenceForForced: 'Has precedence for forced',
                actions: 'Actions'
            },
            perDayTypeOptions: {
                'has-orders': 'For days with orders',
                'has-orders-count-per-five': 'For days with orders (5 paid days per week)',
                'since-first-login': 'For Logging to system'
            },
            editor: {
                create: 'Create commission',
                edit: 'Edit commission',
                removeQuestion: 'Would you like to remove this commission?',
                removeDescription: 'This commission will be completely removed.',
            },
            borders: {
                title: 'Price Thresholds',
                actions: 'Actions',
                create: 'Adding a commission threshold',
                edit: 'Editing Commission Threshold',
                cancel: 'Cancel editing',
                notCommissionBorders: 'No threshold has been created for this commission yet',
                leftBorder: 'Left border',
                rightBorder: 'Right Border',
                staticValue: 'Static Commission',
                percentValue: 'Interest commission'
            },
            transfer: {
                title: 'Transfer drivers from current commission to selected',
                commission: 'Commission',
                driversCount: 'Drivers count: {0}',
                question: 'Are you sure ?',
                description: 'All drivers who use current commission will be transferred to selected'
            }
        },
        PhotoReport: {
            edit: 'Edit',
            reasonRequestCreate: {
                createReason: 'Create reason',
                photoType: 'Photo type',
                createPhotoType: 'Create photo type',
                reasonName: 'Reason name'
            },
            reasonRequestsList: {
                reasonName: 'Reason name',
                removeTitle: 'Do you want to delete reason?',
                removeDescription: 'This reason will be completely removed',
                table: {
                    '#': '#',
                    name: 'Reason',
                    photo: 'Photo type',
                    actions: 'Actions',
                    createdAt: 'Created at'
                }
            },
            photoReportsList: {
                completeTitle: 'Do you want to complete photo report?',
                completeDescription: 'Description',
                removeTitle: 'Do you want to delete photo report?',
                removeDescription: 'This photo report will be completely removed',
                editTitle: 'Edit photo report',
                activity: 'Activity',
                activeRequest: 'Active requests',
                finishedRequest: 'Finished request',
                filters: {
                    name: 'Name',
                    reason: 'Reason',
                    brand: 'Brand',
                    callSign: 'Call sign'
                },
                table: {
                    '#': '#',
                    requestName: 'Name',
                    active: 'Activity',
                    reasonName: 'Reasons',
                    acceptedDrivers: 'Accepted drivers',
                    rejectedDrivers: 'Rejected drivers',
                    allDrivers: 'Number of drivers',
                    newDrivers: 'New',
                    actions: 'Actions',
                    createdAt: 'Created at',
                }
            },
            requestCreate: {
                filters: {
                    brand: 'Brand',
                    callSign: 'Call sign',
                    checkCallSign: 'Check call sign',
                    callSigns: 'Call signs'
                },
                validation: 'Validation',
                createRequest: 'Create request',
                reason: 'Reason',
                name: 'Photo report name',
                optionClass: 'Option class',
                commission: 'Commission',
                modal: {
                    warning: 'Warning !',
                    info: 'If one of the selected call-signs has already been added to the existing photo report with a similar reason, it will be ignored for this.'
                }
            },
            review: {
                title: 'Photo-report: "{0}"',
                editComment: 'Press Enter to save',
                showPhotoType: 'Show photo type',
                hidePhotoType: 'Hide photo type',
                filters: {
                    request: 'Request',
                    brand: 'Brand',
                    status: 'Status',
                    comment: 'Comment'
                },
                table: {
                    '#': '#',
                    callSign: 'Call sign',
                    brand: 'Brand',
                    name: 'Full name',
                    auto: 'Auto',
                    phoneNumber: 'Phone number',
                    driverCreatedAt: 'Driver created at',
                    commission: 'Commission',
                    images: 'Images',
                    status: 'Status',
                    comment: 'Comment'
                }
            },
            statuses: {
                new: 'New',
                empty: 'Empty',
                remake: 'Remake',
                accepted: 'Accepted',
                rejected: 'Rejected'
            },
            validation: {
                success: 'Success',
                notFound: 'Not found',
                duplicate: 'Duplicate',
                validationError: 'Validation error',
                inOpenRequest: 'In opened photo-report'
            }
        },
        CommissionSystems: {
            table: {
                id: 'System ID',
                name: 'Name',
                brandId: 'Brand',
                createdAt: 'Created At',
                updatedAt: 'Updated At',
                drivers: 'Count of drivers',
                actions: 'Actions',
                period: 'Period',
                startCalcDate: 'Start calculate date',
                onlyForcedOrder: 'Only forced orders'
            },
            editor: {
                create: 'Create commission system',
                edit: 'Edit commission system',
                removeQuestion: 'Would you like to remove this commission system?',
                removeDescription: 'This commission system will be completely removed.',
            },
            errors: {
                alreadyExistSystem: 'System with this name already exist',
                systemHasDrivers: 'System already used by drivers'
            },
            steps: 'Steps of commission system',
            stepsData: {
                count: 'Count of orders',
                commissionId: 'Commission',
                actions: 'Actions',
            },
            transfer: {
                title: 'Transfer drivers from current commission system to selected',
                commission: 'Commission system',
                driversCount: 'Drivers count: {0}',
                question: 'Are you sure ?',
                description: 'All drivers who use current commission system will be transferred to selected'
            }
        },
        Penalties: {
            title: 'Penalty',
            brand: 'Brand',
            table: {
                title: 'Title',
                fixedPenalty: 'Penalty sum',
                brandId: 'Brand',
                actions: 'Actions'
            },
            editor: {
                create: 'Create penalty',
                edit: 'Edit penalty',
                removeQuestion: 'Would you like to remove this penalty?',
                removeDescription: 'This penalty will be completely removed.',
            }
        },
        Logging: {
            models: {
                Client: 'Client',
                Driver: 'Driver',
                Operator: 'Operator',
                ClientBonus: 'Client bonus',
                Tariff: 'Tariff',
                Resale: 'Resale',
                Penalty: 'Penalty',
                Commission: 'Commission',
                CommissionBorder: 'Commission border',
                DriverBonus: 'Driver bonus',
                Settings: 'Settings',
                Report: 'Report'
            },
            actionType: 'Action type',
            user: 'User',
            table: {
                userId: 'User',
                actionTypeId: 'Action type',
                createdAt: 'Created at',
                action: 'Action'
            },
            messages: {
                'change-action-type-status': 'Action type "{0}" was {1}',
                'setting-edit': 'Setting {0} was changes from {1} to {2}.',
                'withBrand': 'With brand {0}',
                'setting-change': 'Set custom [{0}] settings for brand {1}',
                'setting-set-default': 'Set default [{0}] settings for brand {1}',
                'report-change-access': 'Change report access for user {0} {1}.',
                'addAccess': 'Add access: {0}.',
                'removeAccess': 'Remove access: {0}.',
                'categoryReport': 'Report category: ',
                'nameReport': 'Report name: ',
                'report-view': 'Report viewed by [Category: {0}, Name: {1}]',
                'change': '{0} from {1} to {2}',
                'add': 'Added {0}: {1}',
                'user-login': 'User login {0} {1}',
                'delete': '{0} {1} - deleted',
                'operator-delete': 'User {0} (login: {1}) with role "{2}" was removed',
                'edit': '{0} {1} edited: {2}',
                'create': '{0} created with parameters: {1}',
                'deleteField': 'Removed {0} {1}',
                'resale-create': 'Resale from {0} to {1} (option class: {2}) was created with parameters: {3}',
                'resale-edit': 'Fields in resale from {0} to {1} (option class: {2}) was edited: {3}',
                'resale-delete': 'Resale from {0} to {1} (option class: {2}) was removed',
                'change-driver-status': 'Driver {0} was {1}',
                'driverStatus': {
                    'active': 'returned to the air',
                    'disabled': 'removed from the air',
                },
                'enabled': 'enabled',
                'disabled': 'disabled',
                'send-driver-password': 'Password send to driver {0}',
                'passwordChanged': 'User password',
                'operator-back-to-work': 'Operator {0} back to work',
                'financeRemove': '{0} {1} for brand {2} - was deleted',
                'add-driver-payment': 'Driver payment created: {0} \nwith reason: {1}\namount: {2}\ncomment: {3}',
                'reset-imei': 'Reset IMEI of {0} driver',
                'sqlQuery': 'Sql query',
                'meta': 'Meta query',
                'karma-change': 'Driver "{0}" karma was changed from {1} to {2}',
                'option-level-edit': 'Option level was changed from {0} to {1}'
            }
        },
        LoggingEditor: {
            table: {
                action: 'Action',
                enabled: 'Enabled'
            }
        },
        TechnicalSupport: {
            clientAppeals: {
                title: 'Client appeals',
                table: {
                    id: '№',
                    type: 'Type',
                    phoneNumber: 'Phone number',
                    orderId: 'Order id',
                    status: 'Status',
                    reason: 'Reason',
                    comment: 'Comment',
                    dispatcher: 'Dispatcher',
                    actions: 'Actions'
                }
            },
            callTypes: {
                driver: 'Driver',
                client: 'Client'
            },
            statuses: {
                resolved: 'Resolved',
                unresolved: 'Unresolved',
                review: 'On review',
                transferred: 'Transferred to admin',
                rejected: 'Rejected'
            },
            CardEditor: {
                title: 'Appeal card',
                form: {
                    type: 'Who called ?',
                    phoneNumber: 'Phone number',
                    orderId: 'Order id',
                    reason: 'Reason',
                    status: 'Status',
                    comment: 'Comment',
                    customReason: ' Input a reason'
                }
            },
            additionalInfo: {
                title: 'Additional info',
                'client-details': 'By phone number',
                'order-details': 'By order id',
                orderData: 'Order data',
                payments: 'System payments',
                paymentsFromFp: 'Payments from FP',
                fpPaymentsTable: {
                    clientId: 'Client ID',
                    phoneNumber: 'Client phone number',
                    orderId: 'Transaction ID',
                    amount: 'Amount',
                    status: 'Status',
                    type: 'Type',
                    createdAt: 'Created at',
                    new: 'New',
                    success: 'Success',
                    error: 'Error',
                    sandbox: 'Sandbox'
                },
                fpBalanceHistoryTable: {
                    id: 'ID',
                    taxiOrderId: 'Taxi order ID',
                    paymentId: 'Payment ID',
                    change: 'Change',
                    balance: 'Balance',
                    paymentType: 'Payment type',
                    createdAt: 'Created at',
                    system: 'System',
                    cashback: 'Cashback',
                    refill: 'Refill',
                    trip: 'Trip'
                },
                orderHistory: 'Last orders',
                balanceHistory: 'Last balance changes',
                fpData: 'Data from FP',
                bonuses: 'Take part at bonus system "{0}" ({1})',
                corporation: 'Belongs to corporation "{0}"',
                group: 'Clients group: "{0}"',
                cashback: 'Belongs to cashback system: "{0}"'
            }
        },
        Establishments: {
            table: {
                name: 'Name',
                'name:uk': 'Name (UK)',
                'name:ru': 'Name (RU)',
                'name:en': 'Name (EN)',
                description: 'Description',
                'description:uk': 'Description (UK)',
                'description:ru': 'Description (RU)',
                'description:en': 'Description (EN)',
                status: 'Status',
                cookTime: 'Cook time',
                minimalPrice: 'Minimal price',
                place: 'Place',
                type: 'Type',
                margin: 'Margin',
                category: 'Category',
                brand: 'Brand',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                actions: 'Actions',
                order: 'Ordering',
                position: 'Position',
                openTime: 'Opening at',
                closeTime: 'Closing at',
                closedOnAlarm: 'On alarm',
                commission: 'Commission'
            },
            remove: {
                title: 'Remove establishment',
                question: 'Do you want to remove establishment ?'
            },
            settings: {
                title: 'Settings',
                minutesPerKilometer: 'One km driving time'
            },
            active: 'Active',
            inactive: 'Inactive',
            opened: 'Opened',
            closed: 'Closed',
            closedOnAlarm: 'Closed on alarm',
            openOnAlarm: 'Open on alarm'
        },
        EstablishmentEditor: {
            name: 'Name',
            description: 'Description',
            status: 'Status',
            cookTime: 'Cook time (min)',
            minimalPrice: 'Minimal price',
            place: 'Addresses',
            type: 'Type',
            category: 'Category',
            brand: 'Brand',
            managerPhoneNumber: 'Manager phone number',
            create: 'Create establishment',
            edit: 'Edit establishment',
            openTime: 'Opening at',
            closeTime: 'Closing at',
            commission: 'Commission'
        },
        DriverNewsEditor: {
            articleData: 'Article data'
        },
        DriverNews: {
            sendTo: {
                all: 'All drivers',
                selected: 'Chosen drivers'
            },
            delete: 'Delete',
            cancel: 'Cancel',
            table: {
                text: 'Text',
                sendTo: 'Send to',
                header: 'Title',
                status: 'Status',
                createdAt: 'Created at',
                actions: 'Actions',
                id: 'ID'
            },
            status: {
                shown: 'Shown',
                hide: 'Hidden'
            },
            deleteTitle: 'Are you sure to delete this article?',
            cannotBeUndone: 'This action cannot be undone'
        },
        AddDriverArticle: {
            sendTo: {
                all: 'All',
                selected: 'Manual'
            }
        },
        News: {
            selects: {
                all: 'All',
                leader: 'Leaders',
                business: 'Businesses'
            },
            count: 'Count of news',
            header: 'Information for partners',
            showTo: 'Show to',
            showText: 'Publication',
            latePublication: 'Late publication',
            publicationDate: 'Publication date',
            publicationTime: 'Publication time',
            text: 'News text',
            image: 'Choose an image',
            share: 'Choose a referral code for sharing',
            noCode: 'You haven\'t any referral code. Create it before sharing',
            edit: 'Edit publication',
            create: 'New publication',
            shareImageBlock: {
                code: {
                    size: 'Size(px)',
                    position: 'Position',
                    positions: {
                        'top-left': 'Top left',
                        'top-right': 'Top right',
                        'bottom-left': 'Bottom left',
                        'bottom-right': 'Bottom right'
                    }
                },
                addQRCode: 'Add QR code'
            }
        },
        Notification: {
            count: 'Number of notifications',
            drivers: 'Ready to send',
            filters: {
                selectAll: 'Select all drivers',
                phones: 'Callsigns',
                success: 'Success',
                duplicate: 'Duplicate',
                notFound: 'Not found',
                withoutToken: 'Without token',
                validationError: 'Validation error'
            },
            message: {
                title: 'Title *',
                body: 'Text',
                image: 'Image link'
            },
            result: {
                title: 'Results',
                androidSuccess: 'Android success',
                androidFailure: 'Android failure',
                iosSuccess: 'iOS success',
                iosFailure: 'iOS failure'
            },
            error: {
                emptyToken: 'Device token not sent',
                requiredData: 'The request body field was not sent',
                CouldNotParsed: 'The request body could not be read',
                InvalidRegistration: 'Invalid registration',
                NotRegistered: 'Not registered',
                InvalidPackageName: 'Invalid package name',
                MismatchSenderId: 'Mismatch sender id',
                InvalidParameters: 'Invalid parameters',
                MessageTooBig: 'Message too big',
                InvalidDataKey: 'Invalid data key',
                Unavailable: 'Unavailable',
                DeviceMessageRateExceeded: 'Device message rate exceeded',
                BadCollapseId: 'Bad collapse id',
                BadDeviceToken: 'Bad device token',
                BadExpirationDate: 'Bad expiration date',
                BadMessageId: 'Bad message id',
                BadPriority: 'Bad priority',
                BadTopic: 'Bad topic',
                DeviceTokenNotForTopic: 'Device token not for topic',
                DuplicateHeaders: 'Duplicate headers',
                IdleTimeout: 'Idle timeout',
                MissingDeviceToken: 'Missing device token',
                MissingTopic: 'Missing topic',
                PayloadEmpty: 'Payload empty',
                TopicDisallowed: 'Topic disallowed',
                BadCertificate: 'Bad certificate',
                BadCertificateEnvironment: 'Bad certificate environment',
                ExpiredProviderToken: 'Expired provider token',
                Forbidden: 'Forbidden',
                InvalidProviderToken: 'Invalid provider token',
                MissingProviderToken: 'Missing provider token',
                BadPath: 'Bad path',
                MethodNotAllowed: 'Method not allowed',
                Unregistered: 'Unregistered',
                PayloadTooLarge: 'Payload too large',
                TooManyProviderTokenUpdates: 'Too many provider token updates',
                TooManyRequests: 'Too many requests',
                InternalServerError: 'Internal server error',
                ServiceUnavailable: 'Service unavailable',
                Shutdown: 'Shutdown'
            }
        },
        EstablishmentsCategories: {
            table: {
                name: 'Name',
                'name:uk': 'Name (UK)',
                'name:ru': 'Name (RU)',
                'name:en': 'Name (EN)',
                enabled: 'Status',
                image: 'Image',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                actions: 'Actions',
                create: 'Create category',
                edit: 'Edit category',
                order: 'Ordering',
                position: 'Position'
            }
        },
        EstablishmentsTypes: {
            table: {
                name: 'Name',
                'name:uk': 'Name (UK)',
                'name:ru': 'Name (RU)',
                'name:en': 'Name (EN)',
                description: 'Description',
                'description:uk': 'Description (UK)',
                'description:ru': 'Description (RU)',
                'description:en': 'Description (EN)',
                status: 'Status',
                statuses: {
                    draft: 'Draft',
                    publish: 'Publish'
                },
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                actions: 'Actions',
                create: 'Create type',
                edit: 'Edit type'
            },
            deletingType: 'Deleting establihment type',
            areYouSureToDelete: 'Are you sure to delete this establishment type?'
        },
        Sections: {
            table: {
                name: 'Name',
                'name:uk': 'Name (UK)',
                'name:ru': 'Name (RU)',
                'name:en': 'Name (EN)',
                establishmentAddress: 'Establishment address',
                description: 'Description',
                'description:uk': 'Description (UK)',
                'description:ru': 'Description (RU)',
                'description:en': 'Description (EN)',
                status: 'Status',
                statuses: {
                    draft: 'Draft',
                    publish: 'Publish'
                },
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                actions: 'Actions',
                margin: 'Margin',
                create: 'Create section',
                edit: 'Edit section',
                establishment: 'Establishment',
                order: 'Ordering',
                position: 'Position'
            },
            deleting: 'Deleting section',
            areYouSureToDelete: 'Are you sure about deleting this section?'
        },
        Products: {
            table: {
                name: 'Name',
                'name:uk': 'Name (UK)',
                'name:ru': 'Name (RU)',
                'name:en': 'Name (EN)',
                weight: 'Quantity',
                establishmentAddress: 'Establishment address',
                isByWeight: 'By weight',
                price: 'Price',
                shortDescription: 'Short description',
                'shortDescription:uk': 'Short description (UK)',
                'shortDescription:ru': 'Short description (RU)',
                'shortDescription:en': 'Short description (EN)',
                detailedDescription: 'Detailed description',
                'detailedDescription:uk': 'Detailed description (UK)',
                'detailedDescription:ru': 'Detailed description (RU)',
                'detailedDescription:en': 'Detailed description (EN)',
                status: 'Status',
                brand: 'Brand',
                published: 'Availability',
                section: 'Section',
                image: 'Image',
                createdAt: 'Created at',
                establishmentPrice: 'Price (establishment)',
                clientPrice: 'Price (client)',
                updatedAt: 'Updated at',
                actions: 'Actions',
                establishment: 'Establishment'
            },
            quantityTypes: {
                pc: 'pc',
                g: 'g',
                kg: 'kg',
                ml: 'ml'
            },
            dblClickToEdit: 'Double-click on a price to edit it',
            create: 'New product',
            edit: 'Edit product',
            remove: {
                title: 'Remove product',
                question: 'Do you want to remove product ?'
            },
            statuses: {
                review: 'Review',
                draft: 'Draft',
                'not-available': 'Not available',
                publish: 'Publish'
            }
        },
        404: {
            title: 'Oops!',
            text: 'Looks like you\'re in uncharted territory. We don\'t know about this page yet. Luckily, we know the way back.',
            return: 'Back'
        }
    },
    buttons: {
        submit: 'Submit',
        cancel: 'Cancel',
        save: 'Save',
        change: 'Change',
        remove: 'Remove',
        upload: 'Upload',
        selectAll: 'Select all',
        edit: 'Edit',
        excel: 'Download table',
        check: 'Check',
        returnToSearch: 'Return to search',
        reset: 'Reset',
        apply: 'Apply',
        ok: 'OK',
        find: 'Find',
        clear: 'Clear',
        create: 'Create',
        validate: 'Validate',
        generate: 'Generate',
        generateInExcel: 'Generate in Excel',
        backToWork: 'Back to work',
        hide: 'Hide',
        send: 'Send',
        complete: 'Complete',
        blocked: 'Blocked',
        add: 'Add',
        confirm: 'Confirm',
        restore: 'Restore',
        transfer: 'Assign',
        duplicate: 'Duplicate',
        browse: 'Browse',
        checkPhones: 'Check phones',
        search: 'Search',
    },
    roles: {
        all: 'All',
        intern: 'Intern',
        operator: 'Operator',
        accountant: 'Accountant',
        manager: 'Manager',
        'corporate-admin': 'Corporate administrator',
        'corporate-user': 'Corporate user',
        boss: 'Boss',
        client: 'Client',
        admin: 'Administrator',
        'sales-manager': 'Sales manager',
        driver: 'Driver',
        leader: 'Leader',
        'admin-delivery': 'Delivery admin',
        'admin-establishment': 'Restaurant admin',
        'manager-establishment': 'Restaurant manager',
        'manager-establishment-ext': 'Restaurant manager (extended)'
    },
    locales: {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська'
    },
    messages: {
        error: {
            badRequest: 'Fill required fields',
            missedImportCsv: 'File import.csv (.xml) is missing in the archive',
            uploadFileError: 'Error in file import.csv (.xml)',
            orderNotFound: 'Order not found',
            borderIsAlreadyExist: 'The boundaries of this threshold intersect with the boundaries of another threshold',
            existPaymentByPenalty: 'The system already has payments with a given fine.',
            duplicateCallSign: 'Call sign already exists. Chose other Call sign.',
            cantDeleteCorpAdmin: "Unable to delete corporate administrator with users",
            duplicateLoginName: 'User already exists. Choose other Login.',
            duplicatePhoneNumber: 'User with this Phone number already exists.',
            invalidPhone: 'Invalid phone',
            autologout: 'Session was closed due to lack of activity',
            invalidLogin: 'Login is not valid',
            notFoundCallSign: 'Call signs not found',
            invalidPassword: 'Password is not valid',
            requiredPhoneNumber: 'SIP is required',
            invalidOperator: 'Operator is not found',
            accountRemoved: 'Account has been deleted',
            invalidFormat: 'Invalid data format',
            invalidInteger: 'Need to write an integer value. For example: 100',
            invalidDecimal: 'It is necessary to write a fractional or integer value. For example: 20 or 20.5',
            invalidBoolean: 'Only true or false are possible',
            withoutType: 'Incorrect value type or value type not passed',
            driversNotFound: 'No drivers were found',
            imageIsTooLarge: 'Upload photo with file size less than 5mb',
            findRequestWithThisReason: 'Unable to delete the reason, if there is an active photo report with this reason',
            cannotChangeReason: 'Unable to change the reason, if there is an active photo report with this reason',
            requestAlreadyCompleted: 'Photo request already completed',
            unknown: 'Unknown error',
            brand: {
                alreadyExists: 'Brand with such code or phone number is already exists',
                brandNotFound: 'Brand was not found'
            },
            notifications: {
                InvalidRegistration: 'Invalid registration',
                NotRegistered: 'Not registered',
                InvalidPackageName: 'Invalid package name',
                MismatchSenderId: 'Mismatch sender id',
                InvalidParameters: 'Invalid parameters',
                MessageTooBig: 'Message too big',
                InvalidDataKey: 'Invalid data key',
                Unavailable: 'Unavailable',
                InternalServerError: 'Internal server error',
                DeviceMessageRateExceeded: 'Device message rate exceeded',
                invalidToken: 'Invalid device token',
                emptyToken: 'Device token not sent',
                requiredData: 'Field with request body not sent',
                couldNotParsed: 'Unable to read request body',
                noRecords: 'No records found',
                unknown: 'Unknown error',
                preOrderTime: 'Incorrect preorder time'
            },
            payments: {
                emptyPayment: "Unable to make an empty payment.",
                zeroPayment: "Unable to make a zero payment.",
                emptyPenalty: "Sum should be more than 0.",
                isNotNumericPaymentSum: "Sum should be in numeric.",
                moreThenMaxBalance: "Unable to make payment more than 1 000 000 UAH",
                lessThenMinBalance: "Unable to make payment more than 1 000 000 UAH",
                emptyPaymentTypeId: "Payment type required",
                invalidPaymentTypeId: "Payment type not found",
                emptyOrderId: "Order required",
                findMoreThanOnePayment: "Find more than one payment!",
                orderNotFound: "The order is missing or belongs to another driver"
            },
            support: {
                paymentsNotFound: 'Payments were not found',
                orderNotFound: 'Order not found',
                incorrectPhoneNumber: 'Incorrect phone number',
                clientNotFound: 'Client not found'
            },
            addresses: {
                alreadyExist: 'An address with the specified parameters already exists!'
            },
            forms: {
                alreadyHasAnswers: 'This question has answers'
            },
            optionClasses: {
                notFound: 'Option class was not found',
                foundOptions: 'Found options with this class'
            },
            paymentTypes: {
                notFound: 'Payment type was not found',
                foundPayments: 'Found payments with this type'
            },
            cantReturnRemovedDriver: 'You can\'t return fired driver to the air',
            optionClassExist: 'This option class already for another brand',
            cantCancelActiveOrder: 'You cant cancel active order',
            wrongToken: 'Wrong authorization token',
            requiredAuthorizationToken: 'Authorization token is required',
            driverInActivePhotoReport: 'This driver is in active photo report',
            lessThanMin: 'Less than minimum value',
            moreThanMax: 'Greater than maximum value',
            driverRestricted: 'This driver not from your brand',
            tooManyChars: 'Chars limit exceeded',
            fileSizeExceeded: 'Max file size is: {0} mb'
        },
        success: {
            deletedArticle: 'Article was deleted',
            savedArticle: 'Article was deleted',
            createdArticle: 'Created article',
            foundCallSign: 'Call sign found',
            createdPhotoRequest: 'Photo request created for {0} drivers',
            closedPhotoRequest: 'Photo request successfully finished',
            success: 'Success operation',
            duplicate: 'Order successfully duplicated',
            copy: 'Copied to clipboard'
        }
    },
    browserNotify: {
        message: 'Notification',
        applyNotifications: 'You allowed to show browser notifications',
        new: 'New order',
        cancel: 'Order cancelled',
        sos: 'SOS',
        late: 'Being late to order',
        client: 'Client: ',
        address: 'Address: ',
        availability: 'No available cars',
        'client-refused': 'Client refused',
        driver: 'Driver refused',
        operator: 'Cancelled by operator'
    },
    statuses: {
        all: 'All',
        new: 'New',
        waiting: 'Waiting',
        searching: 'Searching',
        accepted: 'Accepted',
        arrived: 'Arrived',
        landed: 'Landed',
        completed: 'Completed',
        cancelled: 'Cancelled',
        pause: 'Order on pause',
        delivery: {
            all: 'All',
            new: 'New',
            accepted: 'Accepted',
            canceledKitchen: "Cancelled by kitchen",
            notAccepted: "Not accepted",
            paid: "Paid",
            paymentWait: "Waiting for payment",
            cooking: "Cooking",
            canceledClient: "Client canceled",
            canceledClientPayment: "Canceled (after payment)",
            readyForDelivery: "Ready for delivery",
            handedToCourier: "Handed to courier",
            delivered: "Delivered",
            null: 'No info',
            undefined: 'No info'
        }
    },
    scopes: {
        taxi: 'Taxi',
        delivery: 'Delivery',
        all: 'All'
    },
    actionTypes: {
        'setting-edit': 'Setting edit',
        'setting-change': 'Setting change',
        'setting-set-default': 'Setting set default',
        'report-change-access': 'Report change access',
        'report-view': 'Report view',
        'client-create': 'Client create',
        'client-edit': 'Client edit',
        'driver-create': 'Driver create',
        'driver-edit': 'Driver edit',
        'driver-delete': 'Driver delete',
        'operator-create': 'Operator create',
        'operator-edit': 'Operator edit',
        'operator-delete': 'Operator delete',
        'user-login': 'User login',
        'client-bonus-create': 'Client bonus create',
        'client-bonus-edit': 'Client bonus edit',
        'tariff-create': 'Tariff create',
        'tariff-edit': 'Tariff edit',
        'tariff-delete': 'Tariff delete',
        'resale-create': 'Resale create',
        'resale-edit': 'Resale edit',
        'resale-delete': 'Resale delete',
        'commission-create': 'Commission create',
        'commission-edit': 'Commission edit',
        'commission-delete': 'Commission delete',
        'commission-border-create': 'Commission border-create',
        'commission-border-edit': 'Commission border edit',
        'commission-border-delete': 'Commission border delete',
        'penalty-create': 'Penalty create',
        'penalty-edit': 'Penalty edit',
        'penalty-delete': 'Penalty delete',
        'driver-bonus-create': 'Driver bonus create',
        'driver-bonus-edit': 'Driver bonus edit',
        'change-driver-status': 'Driver status change',
        'change-action-type-status': 'Activity settings changes',
        'client-bonus-delete': 'Client bonus delete',
        'driver-bonus-delete': 'Driver bonus delete',
        'send-driver-password': 'Sending a driver password',
        'operator-back-to-work': 'Return to work',
        'report-edit': 'Report edit',
        'report-create': 'Report create',
        'add-driver-payment': 'Create driver payment',
        'reset-imei': 'Reset IMEI',
        'karma-change': 'Karma change',
        'option-level-edit': 'Option level edit'
    },
    reasons: {
        all: 'All',
        timeout: 'Timeout',
        'broken-connection': 'Broken connection',
        'no-more-cars': 'No cars',
        'not-order': 'Not order',
        police: 'Police',
        'client-refused': 'Client refused',
        breakdown: 'breakdown',
        other: 'Other',
        null: 'Not SOS',
        'accidental-accept': 'Accidental acceptation',
        'no-connection-with-driver': 'No connection with driver',
        answerphone: 'Answerphone'
    },
    driverStatuses: {
        all: 'All',
        active: 'Active',
        disabled: 'Disabled',
        online: 'Online',
        removed: 'Removed',
        offline: 'Offline'
    },
    operatorStatuses: {
        all: 'All',
        online: 'Online',
        offline: 'Offline',
        removed: 'Removed'
    },
    bonusSystem: {
        'true': 'Active',
        'false': 'Inactive'
    },
    noDataText: 'Data is empty',
    dataIterator: {
        loadingText: 'Loading'
    },
    table: {
        load: 'Data is loading...',
        noData: 'Data is not available'
    },
    date: {
        fromDate: 'Start date',
        toDate: 'End date',
        date: 'Date'
    },
    close: 'Close',
    others: 'others',
    applyFilters: 'Apply filters',
    filters: 'Filters',
    system: 'System',
    status: 'Status',
    outOf: 'out of',
    currency: 'UAH',
    answers: {
        yes: 'Yes',
        no: 'No'
    },
    title: 'Title',
    apiVersion: 'API version',
    clientVersion: 'Client version',
    orderId: 'Order ID',
    chooseImage: 'Choose image',
    pagination: {
        ariaLabel: {
            previous: 'previous',
            page: 'page',
            next: 'next',
            wrapper: 'wrapper',
            currentPage: 'current page'
        }
    }
};
